export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00485.569e6aa2.png";